import React from "react";
import { useHugeLikeButtonConfiguration } from "../../../../hooks";
import { StyledHugeLikeButton } from "./styled"

const HugeLike = ({ metaURL }) => {
    const { hugeLikeText, hugeLikeTextHandler } = useHugeLikeButtonConfiguration(metaURL);

    return (
        <StyledHugeLikeButton onClick={hugeLikeTextHandler}>
            {hugeLikeText}
        </StyledHugeLikeButton>
    );
};
export default HugeLike;

